module.exports = __webpack_public_path__ + "static/img/brand_back_yihao_details.c66726c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/brand_back_yihao_details.png
// module id = QX85
// module chunks = 1